type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

window.dataLayer = window.dataLayer || [];

type PurchaseEventTracking = {
  paymentId: string;
  coupon: string;
  productId: string;
  productName: string;
  productPrice: number;
};

type ViewItemEventTracking = {
  productId: string;
  productName: string;
  productPrice: number;
};

type AddToCartEventTracking = {
  productId: string;
  productName: string;
  productPrice: number;
};

type BeginCheckoutEventTracking = {
  productId: string;
  productName: string;
  productPrice: number;
};

class EcommerceEventTracking {
  static instance: EcommerceEventTracking;
  static window = window as any;
  private constructor() {
    // Private constructor to prevent direct instantiation
  }

  static getInstance() {
    if (!EcommerceEventTracking.instance) {
      EcommerceEventTracking.instance = new EcommerceEventTracking();
    }
    return EcommerceEventTracking.instance;
  }

  sendPurchaseEvent(data: PurchaseEventTracking) {
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: data.paymentId,
          coupon: data.coupon,
          currency: 'BRL',
          value: data.productPrice,
          items: [
            {
              item_id: data.productId,
              item_name: data.productName,
              price: data.productPrice,
              quantity: 1
            }
          ]
        }
      });
    } catch (error) {
      console.error('Error sending purchase event', error);
    }
  }

  sendViewItemEvent(data: ViewItemEventTracking) {
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'BRL',
          value: data.productPrice,
          items: [
            {
              item_id: data.productId,
              item_name: data.productName,
              price: data.productPrice,
              quantity: 1
            }
          ]
        }
      });
    } catch (error) {
      console.error('Error sending view item event', error);
    }
  }

  sendAddToCartEvent(data: AddToCartEventTracking) {
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'BRL',
          value: data.productPrice,
          items: [
            {
              item_id: data.productId,
              item_name: data.productName,
              price: data.productPrice,
              quantity: 1
            }
          ]
        }
      });
    } catch (error) {
      console.error('Error sending add to cart event', error);
    }
  }

  sendBeginCheckoutEvent(data: BeginCheckoutEventTracking) {
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: 'BRL',
          value: data.productPrice,
          items: [
            {
              item_id: data.productId,
              item_name: data.productName,
              price: data.productPrice,
              quantity: 1
            }
          ]
        }
      });
    } catch (error) {
      console.error('Error sending begin checkout event', error);
    }
  }
}

export const EcommerceEventTrackingInstance = EcommerceEventTracking.getInstance();
